import { Link, Stack } from "@mui/material";

export default function AboutPage() {
  return (
    <Stack
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      sx={{ m: 2 }}
    >
      <Link href="https://qm.qq.com/q/SuUG96zC8e">
        点击链接加入群聊：1070376554
      </Link>

      <img src="qrcode_1070376554.jpg" alt="QQ group"></img>
    </Stack>
  );
}
